customElements.get("custom-media-gallery") ||
  customElements.define(
    "custom-media-gallery",
    class extends HTMLElement {
      constructor() {
        super();
        this.mediaSources = [];
        this.currentIndex = 0;
        this.initialize();
        this.createModal();
      }

      initialize() {
        const originalViewer = this.querySelector('[id^="GalleryViewer"]');
        if (!originalViewer) return;

        const galleryContainer = document.createElement("div");
        galleryContainer.className = "custom-gallery-container";
        galleryContainer.style.cssText = `
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    width: 100%;
    padding: 10px 0;
  `;

        const mediaItems = originalViewer.querySelectorAll("[data-media-id]");
        this.mediaSources = [];

        mediaItems.forEach((item, index) => {
          const mediaContent = item.querySelector("img, video");

          if (!mediaContent) return;

          // Wichtig: Verwende getAttribute('src') (nicht .src), um relative Pfade zu erhalten!
          const src = mediaContent.getAttribute("src");

          if (src) {
            this.mediaSources.push(src);

            const clonedContent = mediaContent.cloneNode(true);
            clonedContent.style.cssText = `
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        border: 1px solid #e5e5e5;
        border-radius: 6px;
      `;

            const mediaWrapper = document.createElement("div");
            mediaWrapper.className = "custom-gallery-item";
            mediaWrapper.style.cssText = `
        aspect-ratio: 1 / 1;
        position: relative;
        width: 100%;
        cursor: pointer;
      `;

            mediaWrapper.addEventListener("click", () => {
              this.openModal(this.mediaSources.length - 1);
            });

            mediaWrapper.appendChild(clonedContent);
            galleryContainer.appendChild(mediaWrapper);
          }
        });

        originalViewer.replaceWith(galleryContainer);
      }

      createModal() {
        const modal = document.createElement("div");
        modal.className = "custom-gallery-modal";
        modal.innerHTML = `
        <div class="modal-content">
          <button class="nav-button prev-button" aria-label="Vorheriges Bild">&#10094;</button>
          <div class="swipe-wrapper">
            <img class="modal-image" src="" alt="Zoom Bild">
          </div>
          <div class="spinner" hidden>
            <div class="dot"></div>
          </div>
          <button class="nav-button next-button" aria-label="Nächstes Bild">&#10095;</button>
          <button class="close-button" aria-label="Schließen">×</button>
        </div>
      `;

        const swipeWrapper = modal.querySelector(".swipe-wrapper");

        // Modal schließen
        modal.addEventListener("click", (e) => {
          if (
            e.target === modal ||
            e.target.classList.contains("close-button")
          ) {
            this.closeModal();
          }
        });

        // Keyboard support
        document.addEventListener("keydown", (e) => {
          if (this.modal.style.display !== "flex") return;
          if (e.key === "Escape") this.closeModal();
          if (e.key === "ArrowLeft") this.navigate(-1);
          if (e.key === "ArrowRight") this.navigate(1);
        });

        // Klicknavigation
        modal
          .querySelector(".prev-button")
          .addEventListener("click", () => this.navigate(-1));
        modal
          .querySelector(".next-button")
          .addEventListener("click", () => this.navigate(1));

        // SWIPE-ANIMATION
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let deltaX = 0;
        let isDragging = false;

        swipeWrapper.addEventListener("touchstart", (e) => {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isDragging = true;
          swipeWrapper.style.transition = "none";
        });

        swipeWrapper.addEventListener("touchmove", (e) => {
          if (!isDragging) return;
          currentX = e.touches[0].clientX;
          deltaX = currentX - startX;
          swipeWrapper.style.transform = `translateX(${deltaX}px)`;
        });

        swipeWrapper.addEventListener("touchend", (e) => {
          isDragging = false;
          swipeWrapper.style.transition = "transform 0.25s ease";

          // Bildwechsel oder zurück
          if (Math.abs(deltaX) > 80) {
            deltaX < 0 ? this.navigate(1) : this.navigate(-1);
          } else if (
            Math.abs(e.changedTouches[0].clientY - startY) > 80 &&
            deltaX < 40
          ) {
            this.closeModal();
          }

          swipeWrapper.style.transform = "translateX(0)";
        });

        this.modal = modal;
        this.modalImage = modal.querySelector(".modal-image");
        this.swipeWrapper = swipeWrapper;
        document.body.appendChild(modal);
      }

      openModal(index) {
        this.currentIndex = index;
        this.modalImage.src = this.mediaSources[this.currentIndex];
        this.modal.style.display = "flex";
        document.body.style.overflow = "hidden";
      }

      closeModal() {
        this.modal.style.display = "none";
        document.body.style.overflow = "auto";
      }

      navigate(direction) {
        const nextIndex =
          (this.currentIndex + direction + this.mediaSources.length) %
          this.mediaSources.length;
        const newSrc = this.mediaSources[nextIndex];

        const image = this.modalImage;
        const swipeWrapper = this.swipeWrapper;
        const spinner = this.modal.querySelector(".spinner");

        // Spinner anzeigen
        spinner.hidden = false;

        // Bild ausblenden
        image.style.opacity = "0";
        image.classList.remove("slide-left", "slide-right");

        const preload = new Image();
        preload.src = newSrc;

        preload.onload = () => {
          this.currentIndex = nextIndex;
          image.src = newSrc;

          // Bild animieren
          image.classList.add(direction > 0 ? "slide-right" : "slide-left");

          // Spinner ausblenden + Bild einblenden
          spinner.hidden = true;
          setTimeout(() => {
            image.style.opacity = "1";
          }, 50);
        };

        preload.onerror = () => {
          console.warn("Bild konnte nicht geladen werden:", newSrc);
          image.src = "";
          image.alt = "Bild konnte nicht geladen werden";
          spinner.hidden = true;
          image.style.opacity = "1";
        };
      }
    }
  );

// Style hinzufügen
const styleSheet = document.createElement("style");
styleSheet.textContent = `
.custom-gallery-modal {
  display: none;
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.92);
  z-index: 1000;
  justify-content: center;
  align-items: center;
  touch-action: none;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-image {
max-width: 100%;
max-height: 90vh;
object-fit: contain;
border-radius: 8px;
box-shadow: 0 0 20px rgba(255,255,255,0.2);
transition: opacity 0.25s ease;
opacity: 1;
}


.close-button {
  position: fixed;
  top: 20px;
  right: 25px;
  font-size: 40px;
  color: white;
  background: rgba(0, 0, 0, 0.4);
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  line-height: 1;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.nav-button {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  font-size: 48px;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1001;
  user-select: none;
  padding: 10px;
}

.prev-button {
  left: 20px;
}

.next-button {
  right: 20px;
}

.swipe-wrapper {
display: flex;
justify-content: center;
align-items: center;
transition: transform 0.25s ease;
will-change: transform;
touch-action: pan-y;
}


@media screen and (max-width: 749px) {
  .modal-content {
    max-width: 95vw;
  }

  .close-button {
    top: 10px;
    right: 15px;
    width: 42px;
    height: 42px;
    font-size: 32px;
  }

  .nav-button {
    font-size: 36px;
  }

  .prev-button {
    left: 10px;
  }

  .next-button {
    right: 10px;
  }
  .spinner {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
z-index: 1002;
}

.spinner .dot {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top: 3px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.modal-image.slide-left {
  animation: slideInFromLeft 0.3s ease;
}

.modal-image.slide-right {
  animation: slideInFromRight 0.3s ease;
}

@keyframes slideInFromLeft {
  from {
    transform: translateX(-40px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideInFromRight {
  from {
    transform: translateX(40px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

  }
`;
document.head.appendChild(styleSheet);
